import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '200px',
  minWidth: '100px',
  paddingBottom: 0,
  padding: '0 10px 0px 12px',
  '@media (min-width: 450px)': {
    flex: 1,
    maxWidth: '90%',
  },
});

const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  maxWidth: '200px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: '#414046',
  '@media (min-width: 450px)': {
    maxWidth: '90%',
  },
});
const DetailsTextTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: '#757475',
  span: {
    color: '#414046',
  },
});

const DetailsPriceDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '1px',
});

const DetailsPriceTypographyBold = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#414046',
});

const DetailsPriceTypographyLight = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#414046',
});
export {
  RootDiv,
  TitleTypography,
  DetailsTextTypography,
  DetailsPriceDiv,
  DetailsPriceTypographyBold,
  DetailsPriceTypographyLight,
};
